export default (initialVideoId = null) => ({

    videoId: initialVideoId,

    api: null,

    showOverlay: true,

    init(){
       
       const self = this;

       Rumble('play', {'video': this.videoId,'div':'rumble_' + this.videoId, api: function(api) {
           
            api.on('play', function(){
                self.showOverlay = false;
            });

       }});

       setTimeout(() => {

            let videoEl = self.$el.querySelector('#rumble_' + this.videoId);

            if(!videoEl){

                console.error('player not loaded');
                this.showOverlay = false;
            }

        }, 200)


    },

});